export default "__VITE_ASSET__DuXaqXH___"